module.exports = __webpack_public_path__ + "static/media/insta.0014a4a2.png";